/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Toast_Article_Updated_SuccessInputs */

const en_toast_article_updated_success = /** @type {(inputs: Toast_Article_Updated_SuccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Article updated successfully`)
};

const nl_toast_article_updated_success = /** @type {(inputs: Toast_Article_Updated_SuccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Artikel succesvol bijgewerkt`)
};

/**
* | output |
* | --- |
* | "Article updated successfully" |
*
* @param {Toast_Article_Updated_SuccessInputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
export const toast_article_updated_success = /** @type {((inputs?: Toast_Article_Updated_SuccessInputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Toast_Article_Updated_SuccessInputs, { locale?: "en" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return nl_toast_article_updated_success(inputs)
	return en_toast_article_updated_success(inputs)
});